import React from "react";

type BadgeProps = {
  type?: "primary" | "info" | "success" | "warning" | "danger";
  size: "small" | "medium" | "large";
  label:
    | "training"
    | "trained"
    | "untrained"
    | "idle"
    | "working"
    | "failed"
    | "success"
    | "active"
    | "inactive";
};

const Badge = (props: BadgeProps) => {
  const badgeType = (label) => {
    switch (label.toLowerCase()) {
      case "training":
        return "primary";
      case "trained":
        return "info";
      case "untrained":
        return "warning";
      case "idle":
        return "primary";
      case "working":
        return "primary";
      case "failed":
        return "danger";
      case "success":
        return "success";
      case "active":
        return "success";
      case "inactive":
        return "danger";
      default:
        return "primary";
    }
  };
  return (
    <div className="badge-container">
      <div className={`badge ${badgeType(props.label)} ${props.size}`}>
        <div>{props.label}</div>
      </div>
    </div>
  );
};

export default Badge;
